module.exports = __webpack_public_path__ + "img/hub logo.ed168125.svg";